export const emailUrl =
  "https://w2e9j471i2.execute-api.ap-south-1.amazonaws.com/dev/send-email";
export const mainUrl = "https://collab-beta.iedcmec.in";
export const backendUrl =
  process.env.REACT_APP_BACKEND_URL || "https://collab-api.iedcmec.in";